import { PriceBadge } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/shared/PriceBadge";
import { previewPriceModalProperties } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/shared/PriceBadge/constants";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../";
import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";

export interface TotalDueTodayPreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const TotalDueTodayPreview = ({
  className,
  preview,
  variant = DEFAULT_FULL_PREVIEW_VARIANT.default,
}: TotalDueTodayPreviewProps) => (
  <CheckoutFormSection
    className={classNames("gap-y-3 border-t py-8", className)}
  >
    <DefaultFullPreview.PreviewEntry
      label={
        <>
          {t("paywall_checkout.amount_due")}
          {variant === DEFAULT_FULL_PREVIEW_VARIANT.default && (
            <PriceBadge
              preview={preview}
              properties={previewPriceModalProperties}
            />
          )}
        </>
      }
      labelClassName="flex flex-row gap-x-2 items-baseline"
      labelSize="md"
      labelWeight="semibold"
      value={preview.formatted_amount_due_now}
      valueSize="md"
      valueWeight="semibold"
      dataTestId="checkout-form-preview-total-due-today"
    />
  </CheckoutFormSection>
);
